var _rect, _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 190 54",
    role: "img",
    "aria-label": "Dispon\\xEDvel no Google Play",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 188,
    height: 52,
    rx: 10,
    fill: "#000000",
    stroke: "#A6A6A6",
    strokeWidth: 1.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(17,13)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,1 0,25 12.5,13",
    fill: "#00C8FF"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,1 16.5,9.5 12.5,13",
    fill: "#00E676"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,25 16.5,16.5 12.5,13",
    fill: "#FF3D00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.5,9.5 22,13 16.5,16.5 12.5,13",
    fill: "#FFD600"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 21,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 8.5,
    letterSpacing: 1.2,
    fill: "#FFFFFF"
  }, "DISPON\xCDVEL NO")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 49,
    y: 42,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 21,
    fontWeight: 500,
    fill: "#FFFFFF"
  }, "Google Play")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.1cddce9d7b928690e231a87861a48b38.svg";
export { ForwardRef as ReactComponent };